import type { HttpClient } from "@/core/services/protocols/types";
import { IDefaultContabilResponse } from "@/features/contabil/services/types";
import * as types from "../requests/types";
import { IDashboardLucroGateway } from "./DashboardLucroGateway";

import { injectable, inject } from "inversify";
import "reflect-metadata";
import { DITypes } from "@/core/@types/types";
import DetalhesEvolucaoPatrimonio, {
  IDetalhesEvolucaoPatrimonioParams,
  IDetalhesEvolucaoPatrimonioResponse
} from "./entity/DetalhesEvolucaoPatrimonio";
import TributosSobreLucro from "./entity/TributoSobreLucro";
import Indices from "./entity/Indices";
import EvolucaoPatrimonio from "./entity/EvolucaoPatrimonio";
import IRPJ from "./entity/IRPJ";
import TributosRetidos from "./entity/TributosRetidos";

@injectable()
export default class DashboardLucroHttpGateway
  implements IDashboardLucroGateway
{
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  private httpClient!: HttpClient;

  async getDetalhesEvolucaoPatrimonio(
    params: IDetalhesEvolucaoPatrimonioParams
  ): Promise<DetalhesEvolucaoPatrimonio> {
    const response = await this.httpClient.post<
      IDefaultContabilResponse<IDetalhesEvolucaoPatrimonioResponse>
    >({
      url: "v1/dashboard/lucro/detalhes-evolucao-patrimonio",
      body: { ...params }
    });

    return new DetalhesEvolucaoPatrimonio(response.body?.result);
  }

  async getTributosSobreLucro(
    params: types.ITributosSobreLucroParams
  ): Promise<TributosSobreLucro> {
    const response = await this.httpClient.post<
      IDefaultContabilResponse<types.ITributosSobreLucroResponse>
    >({
      url: "/v1/dashboard/lucro/tributos-lucro",
      body: { ...params }
    });

    return new TributosSobreLucro(response.body?.result);
  }

  async getIndices(params: types.IIndicesParams): Promise<Indices> {
    const response = await this.httpClient.post<
      IDefaultContabilResponse<types.IIndicesResponse>
    >({
      url: "/v1/dashboard/lucro/indices",
      body: { ...params }
    });

    return new Indices(response.body?.result);
  }

  async getEvolucaoPatrimonio(
    params: types.IEvolucaoPatrimonioParams
  ): Promise<EvolucaoPatrimonio> {
    const response = await this.httpClient.post<
      IDefaultContabilResponse<types.IEvolucaoPatrimonioResponse>
    >({
      url: "/v1/dashboard/lucro/evolucao-patrimonio",
      body: { ...params }
    });

    return new EvolucaoPatrimonio(response.body?.result);
  }

  async getIRPJ(params: types.IRPJParams): Promise<IRPJ> {
    const response = await this.httpClient.post<
      IDefaultContabilResponse<types.IRPJResponse>
    >({
      url: "/v1/dashboard/lucro/irpj-csll",
      body: { ...params }
    });

    return new IRPJ(response.body?.result);
  }

  async getTributosRetidos(
    params: types.ITributosRetidosParams
  ): Promise<TributosRetidos> {
    const response = await this.httpClient.post<
      IDefaultContabilResponse<types.ITributosRetidosResponse>
    >({
      url: "/v1/dashboard/lucro/tributos-retidos",
      body: { ...params }
    });

    return new TributosRetidos(response.body?.result);
  }
}
